<template>
	<div
		class="key-points-wrapper"
		v-if="isShowHighlights"
		v-sd-exp:MallItemDetailExpo="moduleTrackingInfo"
	>
		<div class="section-title">配置亮点</div>
		<div class="key-points" v-if="car.highlight_config && car.highlight_config.length">
			<div v-for="item in shownHighlights" class="point">
				<ratio-div>
					<nio-image style="width: 100%;height:100%" :src="item.url" />
				</ratio-div>
				<div>
					{{ item.value }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import RatioDiv from '@/components/RatioDiv'
import link from '@/util/link'
export default {
	name: 'KeyPoints',
	components: { RatioDiv },
	props: ['car'],
	computed: {
		isShowHighlights() {
			return this.car.highlight_config && this.car.highlight_config.length
		},
		shownHighlights() {
			return this.car.highlight_config.concat().splice(0, 6)
		},
		moduleTrackingInfo() {
			return {
				page: '二手车车辆详情页',
				position_rank: 5,
				position_in_rank: 1,
				position_in_number: 1,
				sku_code: this.car.basic.commodity_code,
				module_name: '配置亮点'
			}
		}
	},
	methods: {
		enterConfigDetail() {
			link.goToRoute('/config-detail', { sku_code: this.car.basic.commodity_code, tab: 1 })
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.key-points-wrapper {
	margin-top: 60px;

	.section-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include subtitle_1(1.4, 400, false);
		color: $text_primary;
	}

	.key-points {
		display: grid;
		grid-column-gap: 15px;
		grid-row-gap: 20px;
		grid-template-columns: 1fr 1fr 1fr;
		margin-top: 30px;

		.point {
			display: inline-block;
			width: 100px;

			> :last-child {
				margin-top: 15px;
				@include subtitle_4(1.5, 400, false);
				color: $text_primary;

				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
			}
		}
	}
}
</style>
